import { render, staticRenderFns } from "./CoursewareFolderBlock.vue?vue&type=template&id=f2ad113c&scoped=true&"
import script from "./CoursewareFolderBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareFolderBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareFolderBlock.vue?vue&type=style&index=0&id=f2ad113c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ad113c",
  null
  
)

export default component.exports